import {Injectable} from '@angular/core';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {OverviewListColoredYarnSetWithStartDent} from '@domain/textile-data/creel/overview-list-colored-yarn-set-with-start-dent';
import {OverviewListOrderLine} from '@presentation/pages/texfab/orderbook/overview/overview-list-order-line';
import {IRowNode} from 'ag-grid-community';
import {Observable, Subject} from 'rxjs';

@Injectable()
export class GroupedOrderLinesSelectionService {
  private readonly groupedOrderLinesSelected = new Subject<number[]>();
  public readonly cellRendererParams = new Subject<any>();
  public readonly selectedPath = new Subject<ProductionSchedulePath>();
  public readonly selectedRestPathColoredYarnSet = new Subject<OverviewListColoredYarnSetWithStartDent>();

  private readonly onDetailRowsSelectionChanged = new Subject<{parentNode: IRowNode; parentSelectionState: boolean; orderlinesSelected: OverviewListOrderLine[]}>();
  private readonly SELECTION_STATE = {
    PARTIAL: undefined,
    ALL_SELECTED: true,
    NONE_SELECTED: false
  };

  public getGroupedOrderLineSelected(): Observable<number[]> {
    return this.groupedOrderLinesSelected.asObservable();
  }

  public setGroupedOrderLinesSelected(orderlineIdsSelected: number[]): void {
    this.groupedOrderLinesSelected.next(orderlineIdsSelected);
  }

  public setDetailRowSelected(parentNode: IRowNode, parentSelectionState: boolean, orderlinesSelected: OverviewListOrderLine[]): void {
    this.onDetailRowsSelectionChanged.next({parentNode, parentSelectionState, orderlinesSelected});
  }

  public getdetailRowSelected(): Observable<{parentNode: IRowNode; parentSelectionState: boolean; orderlinesSelected: OverviewListOrderLine[]}> {
    return this.onDetailRowsSelectionChanged.asObservable();
  }

  public getParentSelectionState(nodeData: OverviewListOrderLine[] | number[], selectedOrderLines: number[]): boolean {
    let selectionState: boolean;
    if (nodeData.length === selectedOrderLines.length) {
      selectionState = this.SELECTION_STATE.ALL_SELECTED;
    } else if (selectedOrderLines.length === 0) {
      selectionState = this.SELECTION_STATE.NONE_SELECTED;
    } else {
      selectionState = this.SELECTION_STATE.PARTIAL;
    }

    return selectionState;
  }

  public updateDetailCellRendererParams(params: any): void {
    this.cellRendererParams.next(params);
  }

  public updateSelectedPath(path: ProductionSchedulePath): void {
    this.selectedPath.next(path);
  }

  public updateSelectedRestPathColoredYarnSet(coloredYarnSet: OverviewListColoredYarnSetWithStartDent): void {
    this.selectedRestPathColoredYarnSet.next(coloredYarnSet);
  }
}
